
let url = 'http://api.dev.gdteacher.com';
if (process.env.NODE_ENV === 'development') {
  url = 'https://api.ttcn.cn';
} else if (process.env.NODE_ENV === 'test') {
  url = 'https://api.test.gdteacher.com';
} else if (process.env.NODE_ENV === 'production') {
  url = 'https://api.ttcn.cn';
} else if (process.env.NODE_ENV === 'release') {
  url = 'https://api.ttcn.cn';
}
export const apis = {
  api: {
    preview: 'http://eezxyl.gzedu.com/?furl=', //预览地址
    system:{
      getAPPInfo: url + '/baseData/app-info/search', //获取应用信息
      checkToken: url + '/oauthService/checkToken/',
      gzTeacherProjectLogin: url + '/oauthService/gzTeacherProjectLogin', //广州教师参训项目登录
      gzExpertProjectLogin: url + '/oauthService/gzExpertProjectLogin', //广州区、市级专家登录，继教网账号或平台账号

      period: url + '/baseData/basecode/findCodeByTypeCode',//学段
      subject: url + '/baseData/basecode/subject/getSubjectBySection/',//学科
      getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
      token:url+'/oauthService/teacher/login',
      getUserExpertList: url+'/tsgc2Service/competition-expert/getUserExpertList', //课例观摩分页列表
      
    },
    user:{
      login:url+'/oauthService/oauth/token',
      // login:url+'/oauthService/teacher/login',
      getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
      imageUrl:url+'/captcha/imageUrl',
      checkGroupLeader:url+'/trainService/workshop/checkGroupLeader',   //检验身份
    },
    upload:{    //zhou
      upload: 'https://file.gzteacher.com/apiUpload/upload.do',   //上传地址
    },
    home:{
      getCourseList: url+'/tsgc2Service/tsgc/course-example-view/search', //课例观摩分页列表
      abilityTrain: url+'/tsgc2Service/tsgc/ability-train/search',  //微能力培训列表
      getMicroList: url+'/tsgc2Service/micro-ability/getMicroList', //微能力培训列表1
      baseServer: url + '/baseData',
      courseExampleView: url+'/tsgc2Service/tsgc/course-example-view/search',  //课例观摩分页列表
      courseExample: url+'/tsgc2Service/tsgc/course-example-view', //根据id获取课例观摩的信息
      solveCourse: url+'/tsgc2Service/tsgc/solve-course/',  //保存解课提交的信息
      solveCourseSearch: url+'/tsgc2Service/tsgc/solve-course/search', //获取课例观摩也解课页面视频下方的解课列表接口
      getMicroAbilityAuthenResult: url+'/tsgc2Service/micro-ability/getMicroAbilityAuthenResult', //获取微能力认证情况列表
      getMicroAbilityCompetitionSituation: url+'/tsgc2Service/task-job/getMicroAbilityCompetitionSituation', //微能力大赛(数据统计1)
      getDistrictMicroAbilityCompetitionSituation: url+'/tsgc2Service/task-job/getDistrictMicroAbilityCompetitionSituation', //微能力大赛(数据统计2)
      getArticleByCategoryIds: url+'/yjypService/article/getArticleByCategoryIds/', //获取轮播图列表 
      categorySearch: url+'/yjypService/category/search', //获取轮播图列表

      
    }
  }
};

